{
  "bvo": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "values2020": [
      172453.0,
      103344.0,
      259041.0,
      1034226.0,
      576849.0,
      751403.0,
      1190313.010230954,
      1464065.0,
      546631.0,
      676085.0,
      6997.0,
      1757519.0
    ],
    "values2030": [
      122571.0,
      105617.57575757576,
      259033.0,
      913551.9242424243,
      555049.0,
      696871.0,
      1145551.0,
      1392525.0,
      481739.0,
      699095.0,
      2022.0,
      1636006.0
    ]
  },
  "elec": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "values2020": [
      23887389.526639365,
      9647596.617328519,
      18498956.38267148,
      115261922.0,
      72801710.45730145,
      97256158.20717886,
      113910384.66666667,
      79662651.0,
      48399530.53605919,
      49569539.0,
      393838.0,
      282062649.3333333
    ],
    "values2030": [
      17063422.794062823,
      7303506.628243814,
      26049461.371756185,
      132815197.0,
      60090860.45730145,
      106899649.39130434,
      137120653.0,
      92690377.0,
      53914095.07547993,
      71422465.59836839,
      44476.0,
      284039166.025641
    ]
  },
  "gas": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "values2020": [
      4932333.307150377,
      530812.8663260926,
      7157809.665625902,
      28913455.32254388,
      13566668.707513712,
      25290884.24102744,
      36858164.46368715,
      52998790.0,
      18581035.795683417,
      16660213.675977653,
      134547.0,
      40150480.71415546
    ],
    "values2030": [
      868590.3833772723,
      256506.98128387646,
      1146456.822388295,
      13372370.970812036,
      6015165.0,
      10060016.706641115,
      11551745.648044692,
      19891139.23180347,
      9296455.97369005,
      11987965.340782123,
      22100.0,
      17084090.8389426
    ]
  },
  "kWh_2020": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "gas": [
      48084769,
      5174835,
      69780691,
      281874063,
      132259945,
      246558020,
      359326150,
      516679314,
      181144453,
      162418571,
      1311683,
      391422575
    ],
    "elec": [
      23887389,
      9647596,
      18498956,
      115261922,
      72801710,
      97256158,
      113910384,
      79662651,
      48399530,
      49569539,
      393838,
      282062649
    ],
    "heat": [
      0,
      2152517,
      200001,
      4027809,
      4703926,
      0,
      9545354,
      2033905,
      0,
      21988787,
      200834,
      115557868
    ],
    "total": [
      71972158,
      16974949,
      88479649,
      401163795,
      209765582,
      343814178,
      482781888,
      598375871,
      229543983,
      233976898,
      1906356,
      789043093
    ]
  },
  "kWh_2030": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "gas": [
      8467791,
      2500658,
      11176680,
      130365758,
      58641175,
      98073985,
      112616684,
      193916506,
      90630116,
      116869342,
      215450,
      166550903
    ],
    "elec": [
      17063422,
      7303506,
      26049461,
      132815197,
      60090860,
      106899649,
      137120653,
      92690377,
      53914095,
      71422465,
      44476,
      284039166
    ],
    "heat": [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ],
    "total": [
      25531213,
      9804164,
      37226141,
      263180955,
      118732035,
      204973634,
      249737337,
      286606883,
      144544211,
      188291807,
      259926,
      450590069
    ]
  },
  "cons_per_bvo": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "values1": [
      28.601029307407682,
      5.136368500600835,
      27.631956584578898,
      27.956612309634338,
      23.518578878551775,
      33.65821568589351,
      30.96510257964469,
      36.19975206018859,
      33.99191739159217,
      24.642188002954736,
      19.229241103329997,
      22.84497676221734
    ],
    "values2": [
      7.086426506900264,
      2.428639167714259,
      4.425910298642625,
      14.637778779680488,
      10.837178339209691,
      14.435981274355104,
      10.084008174271327,
      14.284224148078827,
      19.29770264331941,
      17.147834472828617,
      10.9297725024728,
      10.442560014414738
    ],
    "values3": [
      138.5153608614484,
      93.3542016694585,
      71.41323721986666,
      111.44751920760066,
      126.20583628870199,
      129.43275207469077,
      95.69784055755626,
      54.41196326665824,
      88.54150338356074,
      73.31850137186892,
      56.286694297556096,
      160.48910386364716
    ],
    "values4": [
      139.21256083464132,
      69.15048537951267,
      100.5642577268386,
      145.3833038665414,
      108.26226235395696,
      153.39948052265677,
      119.69842721973967,
      66.56281000341107,
      111.91557062118684,
      102.16417739844856,
      21.996043521266074,
      173.61743540405172
    ],
    "values5": [
      417.34361768722067,
      143.42808747420486,
      340.7941117455281,
      383.9934263239693,
      355.48584860027233,
      457.5629569947238,
      397.5731850395591,
      407.3193239067635,
      419.92492915448264,
      313.55245419178544,
      243.75042923157545,
      383.2022439877527
    ],
    "values6": [
      208.29734546968902,
      92.82701877676257,
      143.7119654604946,
      288.0853827697821,
      213.91270985198565,
      294.13425796842535,
      218.00630246535815,
      205.81812408701512,
      300.0467295017252,
      269.33651035911333,
      128.54918122870646,
      275.42079270013494
    ]
  },
  "cons_per_sector": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "values1": [
      4932333,
      530812,
      7157809,
      28913455,
      13566668,
      25290884,
      36858164,
      52998790,
      18581035,
      16660213,
      134547,
      40150480
    ],
    "values2": [
      27831000.0,
      7580000.0,
      31849000.0,
      103471000.0,
      35202000.0,
      54780000.0,
      97946000.0,
      146237000.0,
      48982000.0,
      NaN,
      14048000.0,
      NaN
    ],
    "values3": [
      482000000.0,
      195000000.0,
      611000000.0,
      1736000000.0,
      557000000.0,
      1037000000.0,
      2039000000.0,
      2181000000.0,
      953000000.0,
      946000000.0,
      337000000.0,
      2593000000.0
    ],
    "values4": [
      23887389.526639365,
      9647596.617328519,
      18498956.38267148,
      115261922.0,
      72801710.45730145,
      97256158.20717886,
      113910384.66666667,
      79662651.0,
      48399530.53605919,
      49569539.0,
      393838.0,
      282062649.3333333
    ],
    "values5": [
      95002000.0,
      54480000.0,
      110397000.0,
      446779000.0,
      163562000.0,
      268837000.0,
      528410000.0,
      520216000.0,
      216849000.0,
      255004000.0,
      66865000.0,
      759410000.0
    ],
    "values6": [
      1403000000.0,
      1303000000.0,
      1709000000.0,
      6223000000.0,
      2068000000.0,
      3755000000.0,
      8402000000.0,
      11485000000.0,
      3410000000.0,
      4153000000.0,
      1269000000.0,
      12024000000.0
    ]
  },
  "bvo_per_year_category": {
    "labels": [
      "Drenthe",
      "Flevoland",
      "Friesland",
      "Gelderland",
      "Groningen",
      "Limburg",
      "Noord-Brabant",
      "Noord-Holland",
      "Overijssel",
      "Utrecht",
      "Zeeland",
      "Zuid-Holland"
    ],
    "values1": [
      72425.0,
      39494.0,
      87954.0,
      397007.0,
      268048.0,
      291184.0,
      559734.0,
      1359554.0,
      164180.0,
      408858.0,
      4975.0,
      785120.0594231529
    ],
    "values2": [
      32040.0,
      20000.0,
      27950.0,
      146686.0,
      40943.0,
      166021.0,
      126037.0,
      75575.0,
      17500.0,
      66157.0,
      862.0,
      109225.0
    ],
    "values3": [
      54676.0,
      NaN,
      NaN,
      183655.0,
      58478.0,
      8905.0,
      52097.0,
      436.0,
      28264.0,
      51738.0,
      1160.0,
      30209.0
    ],
    "values4": [
      850.0,
      NaN,
      53111.0,
      81960.0,
      NaN,
      38675.0,
      11310.0,
      1628.0,
      17662.0,
      13000.0,
      NaN,
      10172.0
    ],
    "values5": [
      1958.0,
      3850.0,
      78559.0,
      94734.0,
      136918.0,
      143868.0,
      64048.0,
      166247.0,
      117968.0,
      16091.0,
      NaN,
      156700.0
    ],
    "values6": [
      9404.0,
      38000.0,
      3456.0,
      140419.0,
      3069.0,
      20096.0,
      282912.0,
      24135.0,
      125747.0,
      69189.0,
      NaN,
      255078.0
    ],
    "values7": [
      1100.0,
      2000.0,
      8011.0,
      14769.0,
      70055.0,
      69848.0,
      61975.0,
      34570.0,
      81648.0,
      5790.0,
      NaN,
      224779.9405768471
    ]
  }
}